import React from "react";
import Loading from "./Loading";

const ButtonLoader = ({ size }) => {
  return (
    <div
      style={{
        width: size || 18,
        height: size || 18,
      }}
    >
      <Loading fullSize={true} />
    </div>
  );
};

export default ButtonLoader;
